import { WeatherDay } from "./WeatherDay";

export const Weather = ({ forecasts }) => {
  return (
    <div>
      <h2 style={{ marginTop: "1rem", marginBottom: '2rem' }}>7-Day Forecast</h2>
      <div className="weather-grid">
        {forecasts.length > 0 ? (
          forecasts.map((forecast, idx) => (
            <WeatherDay
              key={idx}
              description={forecast.description}
              date={forecast.date}
            />
          ))
        ) : (
          <h4>No forecasts to show</h4>
        )}
      </div>
    </div>
  );
};
